jQuery(document).ready(function() {
	jQuery( ".product-logo" ).appendTo( ".wp-block-cover" );
});